// Minimal, safe formatting for the assistant's replies: everything is escaped first, then a small subset of
// Markdown is applied (paragraphs, line breaks, **bold**, `code`, bullet and numbered lists, ### headings as bold).
import { esc } from "./ui.ts";

const inline = (t: string) => esc(t)
  .replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>")
  .replace(/`([^`]+)`/g, "<code>$1</code>");

const BULLET = /^\s*[-*•]\s+/;
const NUMBER = /^\s*\d+[.)]\s+/;

/** Splits a block into runs of plain lines, bullet items and numbered items, keeping their order. */
function runs(lines: string[]) {
  const out: { kind: "p" | "ul" | "ol"; lines: string[] }[] = [];
  for (const line of lines) {
    const kind = BULLET.test(line) ? "ul" : NUMBER.test(line) ? "ol" : "p";
    const last = out.at(-1);
    if (last && last.kind === kind) last.lines.push(line);
    else out.push({ kind, lines: [line] });
  }
  return out;
}

export function renderReply(text: string): string {
  return text.replace(/\r\n/g, "\n").trim().split(/\n{2,}/).flatMap((block) => runs(block.split("\n")).map((r) => {
    if (r.kind === "ul") return `<ul>${r.lines.map((l) => `<li>${inline(l.replace(BULLET, ""))}</li>`).join("")}</ul>`;
    if (r.kind === "ol") return `<ol>${r.lines.map((l) => `<li>${inline(l.replace(NUMBER, ""))}</li>`).join("")}</ol>`;
    return `<p>${r.lines.map((l) => (/^#{1,6}\s+/.test(l) ? `<strong>${inline(l.replace(/^#{1,6}\s+/, ""))}</strong>` : inline(l))).join("<br>")}</p>`;
  })).join("");
}
